export default __webpack_public_path__ + "static/media/img_03.aaa131f4.jpg";